export default "__VITE_ASSET__BJaAN$dg__"